import { BdsGrid } from 'blip-ds/dist/blip-ds-react/components';
import { Label } from 'components/Label';
import { TicketMessage, TicketMessageDirection } from 'typings/components/TicketMessage';
import './styles.scss';
import { convertDateToLocal } from 'utils';

type BubleTextProps = {
    message: TicketMessage;
};

export const BubbleText = ({ message }: BubleTextProps) => {
    if (message.direction === TicketMessageDirection.Sent) {
        return (
            <BdsGrid direction="column">
                <div data-testid="left-bubble" className="left-bubble">
                    <Label paragraph={true} variant="fs-14">
                        {message.content}
                    </Label>
                </div>
                <div className="left-legend">
                    <Label variant="fs-10" bold="semi-bold">
                        {convertDateToLocal(message.date)}
                    </Label>
                </div>
            </BdsGrid>
        );
    }
    if (message.direction === TicketMessageDirection.Received) {
        return (
            <BdsGrid direction="column">
                <div data-testid="right-bubble" className="right-bubble">
                    <Label color="white" paragraph={true} variant="fs-14">
                        {message.content}
                    </Label>
                </div>
                <div className="right-legend">
                    <Label variant="fs-10" bold="semi-bold">
                        {convertDateToLocal(message.date)}
                    </Label>
                </div>
            </BdsGrid>
        );
    } else {
        return null;
    }
};
